(() => {
  const REMOVE_SELECTOR = 'cart-remove-button[data-kaching-bundle][data-line-key]';

  function parseBundle(raw) {
    if (!raw) return null;

    const candidates = [raw];
    try {
      candidates.push(atob(raw));
    } catch (_) {
      // Kaching gift metadata is JSON; parent metadata is base64-encoded JSON.
    }

    for (const candidate of candidates) {
      try {
        const value = JSON.parse(candidate);
        if (value && typeof value === 'object' && value.id) return value;
      } catch (_) {
        // Try the next supported Kaching metadata format.
      }
    }

    return null;
  }

  function showRemovalError() {
    const error = document.getElementById('CartDrawer-CartErrors');
    if (!error) return;

    error.textContent = 'Unable to remove this bundle. Please try again.';
    error.style.display = 'block';
  }

  document.addEventListener(
    'click',
    async (event) => {
      if (!(event.target instanceof Element)) return;

      const button = event.target.closest(`${REMOVE_SELECTOR} button`);
      if (!button) return;

      const removeButton = button.closest(REMOVE_SELECTOR);
      const parentBundle = parseBundle(removeButton.dataset.kachingBundle);
      if (!parentBundle?.id || parentBundle.gift) return;

      const linkedGifts = [...document.querySelectorAll(REMOVE_SELECTOR)].filter((element) => {
        const metadata = parseBundle(element.dataset.kachingBundle);
        return metadata?.id === parentBundle.id && Boolean(metadata.gift);
      });

      if (!linkedGifts.length) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (removeButton.dataset.kachingGuardBusy === 'true') return;
      removeButton.dataset.kachingGuardBusy = 'true';
      button.disabled = true;

      const error = document.getElementById('CartDrawer-CartErrors');
      if (error) {
        error.textContent = '';
        error.style.display = 'none';
      }

      try {
        const drawer = removeButton.closest('cart-drawer') || document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender?.().map((section) => section.section || section.id).filter(Boolean) || [];
        const updates = { [removeButton.dataset.lineKey]: 0 };

        linkedGifts.forEach((gift) => {
          updates[gift.dataset.lineKey] = 0;
        });

        const response = await fetch(window.routes?.cart_update_url || '/cart/update', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates,
            sections,
            sections_url: window.location.pathname,
          }),
        });

        if (!response.ok) throw new Error(`Cart update failed with HTTP ${response.status}`);

        const cart = await response.json();
        if (drawer?.renderContents) drawer.renderContents(cart);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'kaching-cart-guard',
            cartData: cart,
          });
        }
      } catch (error) {
        console.error('Kaching linked-gift removal failed', error);
        showRemovalError();
      } finally {
        delete removeButton.dataset.kachingGuardBusy;
        if (button.isConnected) button.disabled = false;
      }
    },
    true
  );
})();
